import { CompanyDataDTO } from '../dto/company-data.dto';

export class CompanyData {
  public id: number;
  public name: string;
  public location: string;
  public numberOfDecimals: number;
  public context: string;
  public token: string;

  public static fromDTO(companyDataDTO: CompanyDataDTO): CompanyData {
    const companyData: CompanyData = new CompanyData();
    companyData.id = companyDataDTO.oid;
    companyData.name = companyDataDTO.name;
    companyData.location = companyDataDTO.city;
    companyData.numberOfDecimals = companyDataDTO.numberOfDecimals;
    companyData.token = companyDataDTO.token;
    companyData.context = companyDataDTO.context;
    return companyData;
  }
}
